import { useSyncExternalStore } from "react";

// Pretend networks around this Mac. `signal` is 1-3 bars; `secure` networks need a password.
export const HOTSPOT = { name: "Sylvester's iPhone", cellular: "5G", battery: 0.76 };

export const NETWORKS = [
  { name: "HUAWEI-5G-VA6P", secure: true, signal: 3 },
  { name: "MTN_HomeFi_7A21", secure: true, signal: 2 },
  { name: "Vodafone_Fibre", secure: true, signal: 2 },
  { name: "TP-Link_5G_3F2A", secure: true, signal: 1 },
  { name: "Guest", secure: false, signal: 2 },
];

const CONNECT_MS = 1100;

// One Wi-Fi state shared by the menu bar, the Wi-Fi menu and Control Center.
let state = {
  on: true,
  current: "HUAWEI-5G-VA6P",
  connecting: null,
  known: ["HUAWEI-5G-VA6P"],
};
let timer = null;
const listeners = new Set();

const emit = (patch) => {
  state = { ...state, ...patch };
  listeners.forEach((listener) => listener());
};

const connect = (name) => {
  clearTimeout(timer);
  emit({ connecting: name });
  timer = setTimeout(() => {
    const known = state.known.includes(name) ? state.known : [...state.known, name];
    emit({ current: name, connecting: null, known });
  }, CONNECT_MS);
};

export const wifi = {
  setOn(on) {
    clearTimeout(timer);
    if (!on) {
      emit({ on: false, current: null, connecting: null });
      return;
    }
    // Turning it back on rejoins the network you were last on.
    emit({ on: true });
    connect(state.known[state.known.length - 1] || NETWORKS[0].name);
  },
  toggle() {
    wifi.setOn(!state.on);
  },
  join(name) {
    if (!state.on || name === state.current || name === state.connecting) return;
    connect(name);
  },
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const useWifi = () => useSyncExternalStore(subscribe, () => state);

export default useWifi;

// Control Center's status line for Wi-Fi.
export const wifiStatus = ({ on, current, connecting }) =>
  !on ? "Off" : connecting ? "Connecting…" : current || "Not Connected";
